// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__tSR2H","info":"UpdateTermsInfo_info__2SFkN"};